import { render, staticRenderFns } from "./AddUserForm.vue?vue&type=template&id=3904f6aa&scoped=true&"
import script from "./AddUserForm.vue?vue&type=script&lang=js&"
export * from "./AddUserForm.vue?vue&type=script&lang=js&"
import style0 from "./AddUserForm.vue?vue&type=style&index=0&id=3904f6aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904f6aa",
  null
  
)

export default component.exports